export const ChartPaletteIds = {
    Default: "default",
    Custom: "custom",
};
export const RECENCY_CHART_COLORS = [
    "#178267", // < 3 months
    "#cc8800", // < 6 months
    "#a14d12", // < 12 months
    "#b3194c", // > 12 months
];
export const DEFAULT_PALETTE_COLORS = [
    "#1919b3",
    "#b3194c",
    "#cc8800",
    "#178267",
    "#177082",
    "#a14d12",
    "#3e5574",
    "#7e1fad",
    "#b81e85",
    "#68891a",
    "#188dbf",
    "#721d28",
];
export const CHART_PALETTES = {
    [ChartPaletteIds.Default]: {
        id: ChartPaletteIds.Default,
        name: "Default",
        colors: DEFAULT_PALETTE_COLORS,
    },
};
export const getPaletteById = (id, config) => {
    if (!id || id === ChartPaletteIds.Default) {
        return CHART_PALETTES[ChartPaletteIds.Default];
    }
    if (id === ChartPaletteIds.Custom && config) {
        if (config.customPalettes && config.customPalettes.length > 0) {
            if (config.selectedCustomPaletteId) {
                const selectedPalette = config.customPalettes.find((p) => p.id === config.selectedCustomPaletteId);
                if (selectedPalette) {
                    return {
                        id: ChartPaletteIds.Custom,
                        name: selectedPalette.name,
                        colors: selectedPalette.colors,
                        isCustom: true,
                    };
                }
            }
            const firstPalette = config.customPalettes[0];
            return {
                id: ChartPaletteIds.Custom,
                name: firstPalette.name,
                colors: firstPalette.colors,
                isCustom: true,
            };
        }
        // Fall back to legacy customPalette field
        if (config.customPalette) {
            return {
                id: ChartPaletteIds.Custom,
                name: config.customPalette.name || "Custom",
                colors: config.customPalette.colors,
                isCustom: true,
            };
        }
    }
    return CHART_PALETTES[ChartPaletteIds.Default];
};
export const createDefaultPaletteConfig = (paletteId) => {
    return {
        default: paletteId,
    };
};
export const getPaletteIdForChartType = (config, chartType = "default") => {
    if (!config) {
        return ChartPaletteIds.Default;
    }
    if (config.overrides &&
        chartType !== "default" &&
        config.overrides[chartType]) {
        return config.overrides[chartType];
    }
    return config.default;
};
// Maintains backward compatibility with the old single-palette system
export const normalizePaletteConfig = (chartPaletteId) => {
    if (!chartPaletteId) {
        return createDefaultPaletteConfig(ChartPaletteIds.Default);
    }
    if (typeof chartPaletteId === "object" && "default" in chartPaletteId) {
        return chartPaletteId;
    }
    return createDefaultPaletteConfig(chartPaletteId);
};
